import { useTranslation } from 'react-i18next';
import Button from '../components/Button';
import Card from '../components/Card';
import { useGameStore } from '../stores/gameStore';
import { useEffect } from 'react';

const Home = () => {
	const { t } = useTranslation();
	const setNavigationTarget = useGameStore((state) => state.setNavigationTarget);
	const resetGame = useGameStore((state) => state.resetGame);

	useEffect(() => {
		console.log('Effect activado');
		resetGame();
	}, [resetGame]);

	return (
		<div className='container-game flex flex-col items-center justify-center min-h-screen py-12'>
			<div className='text-center mb-10 animate-fade-in'>
				<h1 className='text-5xl md:text-6xl font-extrabold mb-4 text-white'>
					<span className='text-yellow-300'>Quiz</span>
					<span className='text-pink-400'>elia</span>
				</h1>
				<p className='text-xl text-white opacity-90'>{t('homeScreen.subtitle')}</p>
			</div>
			<Card className='w-full max-w-md animate-slide-up'>
				<div className='flex flex-col gap-4'>
					<Button variant='primary' onClick={() => setNavigationTarget('/create')} size='lg' fullWidth>
						{t('homeScreen.createGameButton')}
					</Button>
					<Button variant='secondary' onClick={() => setNavigationTarget('/join')} size='lg' fullWidth>
						{t('homeScreen.joinGameButton')}
					</Button>
				</div>
			</Card>
		</div>
	);
};

export default Home;
